var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoingWell3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 83,
    viewBox: "0 0 86 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1968 14.485L44.1068 7.81042C53.1844 5.3781 59.76 9.34606 62.2883 18.7817L69.2196 44.6498C71.7479 54.0854 68.0372 60.8096 58.9597 63.2419L34.0497 69.9165C24.9721 72.3488 18.4202 68.3745 15.8919 58.9388L8.96057 33.0708C6.43228 23.6351 10.1193 16.9173 19.1968 14.485Z",
    fill: "url(#paint0_linear_112_1043)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_112_1043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6273 22.4685L42.5391 17.9371C48.702 16.2857 53.1177 18.7984 54.7485 24.8845L59.2193 41.5698C60.8501 47.6559 58.2823 52.0398 52.1194 53.6912L35.2076 58.2227C29.0447 59.874 24.6451 57.357 23.0143 51.2709L18.5435 34.5856C16.9127 28.4995 19.4644 24.1199 25.6273 22.4685Z",
    fill: "#0062FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_112_1043)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_112_1043",
    maskUnits: "userSpaceOnUse",
    x: 22.213,
    y: 18.8467,
    width: 64,
    height: 64,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 22.213,
    y: 18.8467,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5029 19.8467H39.6792C29.1446 19.8467 23.213 25.7782 23.213 36.3129V65.1673C23.213 75.6402 29.1446 81.6335 39.6792 81.6335H68.5337C79.0375 81.6335 85 75.6402 85 65.1673V36.3129C85 25.7782 79.0066 19.8467 68.5029 19.8467Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.5029 19.8467H39.6792C29.1446 19.8467 23.213 25.7782 23.213 36.3129V65.1673C23.213 75.6402 29.1446 81.6335 39.6792 81.6335H68.5337C79.0375 81.6335 85 75.6402 85 65.1673V36.3129C85 25.7782 79.0066 19.8467 68.5029 19.8467Z",
    fill: "url(#paint1_linear_112_1043)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5029 20.7683C69.0118 20.7683 69.4245 20.3557 69.4245 19.8467C69.4245 19.3377 69.0118 18.9251 68.5029 18.9251V20.7683ZM68.5029 18.9251C67.9939 18.9251 67.5812 19.3377 67.5812 19.8467C67.5812 20.3557 67.9939 20.7683 68.5029 20.7683V18.9251ZM68.5029 18.9251H39.6792V20.7683H68.5029V18.9251ZM39.6792 18.9251C34.242 18.9251 29.8629 20.4587 26.844 23.4776C23.825 26.4966 22.2914 30.8757 22.2914 36.3129H24.1346C24.1346 31.2154 25.5668 27.3614 28.1473 24.781C30.7278 22.2005 34.5818 20.7683 39.6792 20.7683V18.9251ZM22.2914 36.3129V65.1673H24.1346V36.3129H22.2914ZM22.2914 65.1673C22.2914 70.5749 23.8257 74.9528 26.8431 77.9785C29.8609 81.0047 34.2395 82.5551 39.6792 82.5551V80.7119C34.5843 80.7119 30.7298 79.2657 28.1482 76.677C25.5661 74.0878 24.1346 70.2326 24.1346 65.1673H22.2914ZM39.6792 82.5551H68.5337V80.7119H39.6792V82.5551ZM68.5337 82.5551C73.9587 82.5551 78.3367 81.0043 81.3579 77.979C84.3789 74.9538 85.9216 70.5762 85.9216 65.1673H84.0784C84.0784 70.2313 82.6398 74.0868 80.0537 76.6765C77.4677 79.266 73.6126 80.7119 68.5337 80.7119V82.5551ZM85.9216 65.1673V36.3129H84.0784V65.1673H85.9216ZM85.9216 36.3129C85.9216 30.8731 84.3711 26.4942 81.3407 23.4763C78.3108 20.4589 73.9252 18.9251 68.5029 18.9251V20.7683C73.5843 20.7683 77.4472 22.2002 80.04 24.7823C82.6322 27.3638 84.0784 31.218 84.0784 36.3129H85.9216Z",
    fill: "url(#paint2_linear_112_1043)",
    mask: "url(#path-3-outside-1_112_1043)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_112_1043)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_112_1043",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4046 37.2178C52.3755 37.2178 50.7306 38.8627 50.7306 40.8918V46.9193H44.7033C42.6742 46.9193 41.0293 48.5642 41.0293 50.5933C41.0293 52.6224 42.6742 54.2673 44.7033 54.2673H50.7306V60.2939C50.7306 62.323 52.3755 63.9679 54.4046 63.9679C56.4338 63.9679 58.0787 62.323 58.0787 60.2939V54.2673H64.1056C66.1347 54.2673 67.7796 52.6224 67.7796 50.5933C67.7796 48.5642 66.1347 46.9193 64.1056 46.9193H58.0787V40.8918C58.0787 38.8627 56.4338 37.2178 54.4046 37.2178Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4046 37.2178C52.3755 37.2178 50.7306 38.8627 50.7306 40.8918V46.9193H44.7033C42.6742 46.9193 41.0293 48.5642 41.0293 50.5933C41.0293 52.6224 42.6742 54.2673 44.7033 54.2673H50.7306V60.2939C50.7306 62.323 52.3755 63.9679 54.4046 63.9679C56.4338 63.9679 58.0787 62.323 58.0787 60.2939V54.2673H64.1056C66.1347 54.2673 67.7796 52.6224 67.7796 50.5933C67.7796 48.5642 66.1347 46.9193 64.1056 46.9193H58.0787V40.8918C58.0787 38.8627 56.4338 37.2178 54.4046 37.2178Z",
    fill: "url(#paint3_linear_112_1043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7306 46.9193V47.1111H50.9225V46.9193H50.7306ZM41.0293 50.5933H40.8374H41.0293ZM50.7306 54.2673H50.9225V54.0754H50.7306V54.2673ZM58.0787 54.2673V54.0754H57.8868V54.2673H58.0787ZM58.0787 46.9193H57.8868V47.1111H58.0787V46.9193ZM50.9225 40.8918C50.9225 38.9687 52.4815 37.4096 54.4046 37.4096V37.0259C52.2696 37.0259 50.5387 38.7567 50.5387 40.8918H50.9225ZM50.9225 46.9193V40.8918H50.5387V46.9193H50.9225ZM44.7033 47.1111H50.7306V46.7274H44.7033V47.1111ZM41.2212 50.5933C41.2212 48.6701 42.7802 47.1111 44.7033 47.1111V46.7274C42.5682 46.7274 40.8374 48.4582 40.8374 50.5933H41.2212ZM44.7033 54.0754C42.7802 54.0754 41.2212 52.5164 41.2212 50.5933H40.8374C40.8374 52.7283 42.5682 54.4592 44.7033 54.4592V54.0754ZM50.7306 54.0754H44.7033V54.4592H50.7306V54.0754ZM50.9225 60.2939V54.2673H50.5387V60.2939H50.9225ZM54.4046 63.7761C52.4815 63.7761 50.9225 62.217 50.9225 60.2939H50.5387C50.5387 62.429 52.2696 64.1598 54.4046 64.1598V63.7761ZM57.8868 60.2939C57.8868 62.217 56.3278 63.7761 54.4046 63.7761V64.1598C56.5397 64.1598 58.2705 62.429 58.2705 60.2939H57.8868ZM57.8868 54.2673V60.2939H58.2705V54.2673H57.8868ZM64.1056 54.0754H58.0787V54.4592H64.1056V54.0754ZM67.5877 50.5933C67.5877 52.5164 66.0287 54.0754 64.1056 54.0754V54.4592C66.2406 54.4592 67.9714 52.7283 67.9714 50.5933H67.5877ZM64.1056 47.1111C66.0287 47.1111 67.5877 48.6701 67.5877 50.5933H67.9714C67.9714 48.4582 66.2406 46.7274 64.1056 46.7274V47.1111ZM58.0787 47.1111H64.1056V46.7274H58.0787V47.1111ZM57.8868 40.8918V46.9193H58.2705V40.8918H57.8868ZM54.4046 37.4096C56.3278 37.4096 57.8868 38.9687 57.8868 40.8918H58.2705C58.2705 38.7567 56.5397 37.0259 54.4046 37.0259V37.4096Z",
    fill: "url(#paint4_linear_112_1043)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-2_112_1043)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_112_1043",
    x: 0.794325,
    y: 0.173231,
    width: 76.1725,
    height: 75.8127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.63397,
    result: "effect1_foregroundBlur_112_1043"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_112_1043",
    x: 0.172964,
    y: -3.19337,
    width: 107.867,
    height: 107.867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0592
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_112_1043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_112_1043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_112_1043",
    x: 26.6394,
    y: 22.8278,
    width: 57.4488,
    height: 57.4488,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.19497
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_112_1043"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.79665,
    dy: 4.79665
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.75598
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_112_1043",
    result: "effect2_dropShadow_112_1043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_112_1043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_1043",
    x1: 31.6818,
    y1: 11.0477,
    x2: 46.6982,
    y2: 67.0897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_112_1043",
    x1: 54.0588,
    y1: 19.751,
    x2: 54.0588,
    y2: 82.2184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_112_1043",
    x1: 33.0485,
    y1: 27.0449,
    x2: 84.9495,
    y2: 77.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_112_1043",
    x1: 65.883,
    y1: 42.0483,
    x2: 36.0857,
    y2: 43.0198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_112_1043",
    x1: 43.9109,
    y1: 46.1912,
    x2: 66.6256,
    y2: 46.3166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoingWell3);
export default __webpack_public_path__ + "static/media/doing-well3.3edf71ab51af3a11821131a0bea900f7.svg";
export { ForwardRef as ReactComponent };